/* ==========================================================================
   Holofoil — facets.js
   Collection filtering & sorting without full page reloads, using the
   Section Rendering API. The facet form still works as a normal GET form
   when JavaScript is disabled (the Apply button is shown via .no-js-only).
   ========================================================================== */
(function () {
  'use strict';

  var container = null;
  var form = null;
  var debounceTimer = null;

  function getContainer() {
    return document.getElementById('CollectionInner');
  }

  function buildQuery() {
    var params = new URLSearchParams();
    if (!form) {
      var sortOnly = document.querySelector('[data-sort-select]');
      if (sortOnly && sortOnly.value) params.set('sort_by', sortOnly.value);
      return params.toString();
    }
    var data = new FormData(form);
    data.forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    // Sort select lives outside the form element but is associated via form=""
    // FormData already includes it in modern browsers; add manually if missing.
    var sort = document.querySelector('[data-sort-select]');
    if (sort && sort.value && !params.has('sort_by')) params.set('sort_by', sort.value);
    return params.toString();
  }

  function renderPage(query, pushState) {
    var el = getContainer();
    if (!el) return;
    var sectionId = el.getAttribute('data-section-id');
    var base = window.location.pathname;
    var url = base + (query ? '?' + query : '');
    var fetchUrl = base + '?' + (query ? query + '&' : '') + 'section_id=' + encodeURIComponent(sectionId);

    el.classList.add('is-loading');

    fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Filter request failed');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('#CollectionInner');
        var current = getContainer();
        if (fresh && current) {
          // Preserve mobile drawer state across replacement
          var facetsOpen = current.querySelector('.facets.is-open') !== null;
          current.innerHTML = fresh.innerHTML;
          bindForm();
          if (facetsOpen) {
            var facets = current.querySelector('.facets');
            if (facets) facets.classList.add('is-open');
          }
          // Reveal the freshly-inserted product cards.
          if (window.HolofoilAnimations) {
            window.HolofoilAnimations.scan();
          } else {
            current.querySelectorAll('.reveal').forEach(function (el) {
              el.classList.add('is-in');
            });
          }
        }
        if (pushState) window.history.pushState({ facets: true }, '', url);
      })
      .catch(function () {
        // Fall back to a normal page load with the same query.
        window.location.href = url;
      })
      .finally(function () {
        var current = getContainer();
        if (current) current.classList.remove('is-loading');
      });
  }

  function onFormChange() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      renderPage(buildQuery(), true);
    }, 350);
  }

  function bindForm() {
    form = document.getElementById('FacetsForm');
    if (!form) return;

    form.addEventListener('change', onFormChange);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      renderPage(buildQuery(), true);
    });
  }

  function toggleFacetsDrawer(open) {
    var el = getContainer();
    if (!el) return;
    var facets = el.querySelector('.facets');
    if (!facets) return;
    facets.classList.toggle('is-open', open);
    facets.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('drawer-open', open);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-facets-toggle]')) {
      event.preventDefault();
      toggleFacetsDrawer(true);
      return;
    }
    if (event.target.closest('[data-facets-close]')) {
      event.preventDefault();
      toggleFacetsDrawer(false);
      return;
    }

    // Active filter pills & "clear all": fetch instead of navigating.
    var pill = event.target.closest('[data-facet-remove]');
    if (pill) {
      event.preventDefault();
      var url = new URL(pill.href, window.location.origin);
      renderPage(url.searchParams.toString(), true);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-sort-select]')) {
      // The select is associated with the form via the form attribute;
      // trigger a re-render immediately.
      clearTimeout(debounceTimer);
      renderPage(buildQuery(), true);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') toggleFacetsDrawer(false);
  });

  window.addEventListener('popstate', function () {
    if (getContainer()) renderPage(window.location.search.replace(/^\?/, ''), false);
  });

  function init() {
    if (getContainer()) bindForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
